import React from "react";
import { useNavigate } from "react-router-dom";
import jwt_decode from "jwt-decode";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";

function JwtAuth() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  if (localStorage.getItem("accessToken")) {
    var token = localStorage.getItem("accessToken");
    let decoded = jwt_decode(token);
    let currentDate = new Date();

    // JWT exp is in seconds
    if (decoded.exp * 1000 < currentDate.getTime()) {
      localStorage.removeItem("accessToken");
      navigate("/login")
      // Swal.fire({
      //   title: "Session expired",
      //   timerProgressBar: true,
      //   icon: "error",
      //   text:"Please login again...",
      //   confirmButtonText: "OK",
      //   showCloseButton: true,
      // });
    } else {
      //   console.log("Valid token");
    }
  }

  return null;
}

export default JwtAuth;
